module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-9.8bce7f60.md";